"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentCookie = exports.getServerCookie = exports.getCookie = exports.getExpirationDate = exports.setDocumentCookie = exports.setServerCookie = exports.setCookie = void 0;
const tslib_1 = require("tslib");
const cookie_1 = tslib_1.__importDefault(require("cookie"));
tslib_1.__exportStar(require("./types"), exports);
const SET_COOKIE_HEADER_KEY = 'Set-Cookie';
function setCookie(params) {
    params.res ? setServerCookie(params) : setDocumentCookie(params);
}
exports.setCookie = setCookie;
function setServerCookie(params) {
    const { res, key, value, daysBeforeExpiration, secure = true, sameSite = 'lax', domain, expires, } = params;
    if (!res)
        throw new Error('[setServerCookie] "res" param is missing.');
    const cookieOptions = {
        path: '/',
        sameSite,
        secure,
    };
    cookieOptions.expires = daysBeforeExpiration ? getExpirationDate(daysBeforeExpiration) : expires;
    if (domain)
        cookieOptions.domain = domain;
    let headers = res.getHeader(SET_COOKIE_HEADER_KEY) || [];
    /* istanbul ignore next */
    if (!Array.isArray(headers))
        headers = [String(headers)];
    headers.push(cookie_1.default.serialize(key, value, cookieOptions));
    res.setHeader(SET_COOKIE_HEADER_KEY, headers);
}
exports.setServerCookie = setServerCookie;
function setDocumentCookie(params) {
    if (typeof document === 'undefined')
        return '';
    const { key, value, daysBeforeExpiration, secure = process.env.NODE_ENV !== 'development', sameSite = true, domain, expires, } = params;
    const cookie = [`${key}=${value}`, 'path=/'];
    if (daysBeforeExpiration || expires) {
        const date = daysBeforeExpiration ? getExpirationDate(daysBeforeExpiration) : expires;
        cookie.push(`expires=${date.toUTCString()}`);
    }
    if (secure)
        cookie.push(`Secure=${secure}`);
    if (sameSite)
        cookie.push(`SameSite=${sameSite}`);
    if (domain)
        cookie.push(`domain=${domain}`);
    return (document.cookie = cookie.join('; '));
}
exports.setDocumentCookie = setDocumentCookie;
function getExpirationDate(daysBeforeExpiration) {
    return new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * daysBeforeExpiration);
}
exports.getExpirationDate = getExpirationDate;
function getCookie(params) {
    const { req, res, key } = params;
    return req ? getServerCookie({ req, res, key }) : getDocumentCookie(key);
}
exports.getCookie = getCookie;
function getServerCookie(params) {
    const { req, res, key } = params;
    const cookieHeaders = [req.headers?.cookie];
    if (res)
        cookieHeaders.push(res.getHeader(SET_COOKIE_HEADER_KEY));
    const cookies = {};
    for (const header of cookieHeaders) {
        if (!header)
            continue;
        /* istanbul ignore next */
        const headers = Array.isArray(header) ? header : [header];
        headers.filter(v => v).forEach(h => Object.assign(cookies, cookie_1.default.parse(String(h))));
        if (cookies[key])
            return cookies[key];
    }
    return '';
}
exports.getServerCookie = getServerCookie;
function getDocumentCookie(key) {
    if (typeof document === 'undefined')
        return '';
    const name = key + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
exports.getDocumentCookie = getDocumentCookie;
//# sourceMappingURL=index.js.map